const SERVICE_IDENTIFIERS = {
    SOCKET: Symbol('Socket'),
};

export default SERVICE_IDENTIFIERS;
